import type { ActivationState } from '@infra/licence/ActivationClaims';
import type { AppContext } from '@application/context/AppContext';

export function licenceRejectionMessage(errorCode?: ActivationState['errorCode']): string {
  switch (errorCode) {
    case 'TENANT_MISMATCH':
      return 'Ce compte n’appartient pas à l’entité de la licence activée sur ce poste.';
    case 'DEVICE_MISMATCH':
      return 'Licence liée à un autre poste.';
    case 'EXPIRED':
      return 'Licence expirée.';
    case 'TOO_MANY_SALARIES':
      return 'Nombre de salariés supérieur à la limite de la licence.';
    default:
      return 'Licence non valide pour ce compte.';
  }
}

export async function countUsersForTenant(ctx: AppContext, tenantId: string): Promise<number> {
  return ctx.localTables.countByTenant('users', tenantId);
}

/** Session d’un autre tenant que la licence courante → à invalider. */
export function isSessionTenantMismatch(
  sessionTenantId: string | undefined,
  licenceTenantId: string | undefined,
): boolean {
  return Boolean(sessionTenantId && licenceTenantId && sessionTenantId !== licenceTenantId);
}
